var map = {
	"./implantbook.png": 3696,
	"./inews-AEEDC.png": 6462,
	"./inews-IDEM.png": 3035,
	"./inews-IDS.png": 5621,
	"./infodent.png": 481,
	"./infomedix.png": 4364,
	"./tabloid.png": 1113,
	"./tabloidBg.jpg": 6022
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5639;